module.exports = __webpack_public_path__ + "img/Unidad20-4.10861f4c.png";